<template>
    <div class="main">
        <div v-if="clubList && clubList!=''" class="model-box bcw">
            <div class="model-box__bd fs2 c6 clear">
                <van-list v-model="listLoading" :finished="listFinished" @load="onLoadMore" loading-text="努力加载中...">
                    <club-card v-for="item in clubList" :key="item.id" :club="item" class="clubcard"></club-card>  
                </van-list>                             
            </div>
        </div>
        <div v-else class="tac norecord">
            <i class="iconfont">&#xe646;</i><br/>
            暂无记录
        </div>
        <div class="clear bcw buybar">
          <div class="buybar__content clear">
            <van-button v-if="manageType=='manage'" @click="pop()" type="primary" size="large" class="fs3">快速入驻</van-button>
            <router-link v-else :to="{name: 'clubentry'}">
                <van-button type="primary" size="large" class="fs3">快速入驻</van-button>
            </router-link>
          </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue';
import { Rate ,Toast,List} from 'vant';
import ClubCard from '@/components/ClubCard';
Vue.use(Rate).use(Toast).use(List);

export default {
    name: 'ClubEnteredList',
    components:{
        ClubCard
    },
    props: {
        userroles: { // 当前用户角色
            type: Object
        }
    },
    data(){
      return {
        clubList:[],//教练俱乐部列表
        manageType:'',
        listLoading: false,
        listFinished: false,
        page: 1,
        pageSize: 15
      }
    },
    created(){
      // 取团课列表数据
      this.getList()
        
      // 获取用户信息
      this.$http.post('user/judgeLogin').then(res => {
          if(!res.data.code){
            let roles = res.data.value.roles
            if(roles.indexOf('ROLE_COACH') !== -1){
              //教练
              this.manageType='manage'
            }
          }
      });

    },
    methods:{
        pop(){
            Toast.fail('您已入驻教练')
        },
        onLoadMore() {
            // console.log('加载更多'); 
            this.page++ 
            this.getList();   
        },
        getList(){
            let _this = this
            // 取团课列表数据
            // console.log('进入page',_this.page)
            this.$http.post('club/getClubList',{
                page:_this.page,
                limit:_this.pageSize
            }).then(function(res){
                if(!res.data.code){ 
                    let re = res.data.value               
                    _this.clubList = _this.clubList.concat(re.data)

                    _this.listLoading = false;
                    if (re.data.length < _this.pageSize) {
                        _this.listFinished = true;
                    }                 
                    // console.log('最终page',_this.page)              
                }else{
                    Toast.fail(res.data.message)
                    _this.listFinished = true;
                }
            })
        }
    }
}
</script>

<style lang="less">
.clubcard{
    padding-bottom: .1rem;
    border-bottom: 0.01rem #f6f6f6 solid
}

@supports (bottom: constant(safe-area-inset-bottom)) or (bottom: env(safe-area-inset-bottom)) {
  .buybar {
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/ClubEnteredList.vue